export default __webpack_public_path__ + "static/pisa2018-2529629d168dfcfcd6f3f61203496e04.png";